export const findNextObject = <T>(arr: T[], obj: T, field: keyof T): T => {
  const index = arr.findIndex((item) => item[field] === obj[field]);
  if (index === -1 || index === arr.length - 1) {
    return arr[0];
  } else {
    return arr[index + 1];
  }
};
